
import { NgProgress } from 'ngx-progressbar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
    Component,
    OnInit,
    ViewChild,
    ViewContainerRef,
    OnDestroy,
    Inject,
    ElementRef
} from '@angular/core';
import { MarketingService } from '../services/marketing.service';
import { Promotion } from '../models/marketing.model';
import { NgModel } from '@angular/forms';
import { CmsStudioService } from '../cms/cms-studio.service';
import { CmsViewDirectiveService } from '../cms/cmsdirectives/cmsviewdirective.service';
import { CmsViewDirectiveComponent } from '../cms/cmsdirectives/cmsviewdirective.component';
import { CommonService } from '../services';
import { ProductService } from '../services/product.service';
import { Brand } from '../models/brand.model';
import { prontoBrands } from '../models/filter.model';
import { NgProgressService } from '../services/ngProgress.service';
@Component({
    selector: 'app-promotions',
    templateUrl: './promotions.component.html',
    styleUrls: ['./promotions.component.css'],
    providers: [CmsViewDirectiveComponent]
})
export class PromotionsComponent implements OnInit, OnDestroy {
    @ViewChild("ParentWrapper", { static: false }) parentWrapper: ElementRef;

    created = false;
    loadContent = false;
    type = 'P';
    promotionList: Array<Promotion>;
    selectedBrandPromotionList = new Array<Promotion>();
    featuredPromotionList = new Array<Promotion>();
    promotionsBrands = [];
    selectedBrands = [];
    @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
    @ViewChild('brandSelect') private brandSelect: NgModel;
    searchField = '';
    allBrands :  any[];
    cms: any;
    viewChildId = null;

    constructor(
        private activeRouter: ActivatedRoute,
        private marketingService: MarketingService,
        public ngProgress: NgProgressService,
        private router: Router,
        private cmsStudioService: CmsStudioService,
        private commonService: CommonService,
        private productService: ProductService,
        @Inject(CmsViewDirectiveService) private service,
        @Inject(ViewContainerRef) private viewContainerRef
    ) {
    }

    ngOnInit() {
        this.ngProgress.start();
        this.promotionList = new Array<Promotion>();
        this.activeRouter.url.subscribe(value => {
            if (value.length === 0) {
                $('.page-contents').animate({ scrollLeft: 0 }, 400);
            }
            this.marketingService.getPromotionList(this.type).subscribe((value: Array<Promotion>) => {
                this.promotionList = value;
                this.selectedBrandPromotionList = value;
                if ( this.promotionList !== null ) {
                    this.featuredPromotionList = this.promotionList?.filter(featured => (featured.topSpot && featured.topSpot == true));
                    this.promotionsBrands = this.promotionList?.map(data => data.brand).sort();
                    this.productService.GetBrandList().subscribe((value:any) => {
                        this.allBrands = value;
                        this.promotionList.forEach(pl => {
                            pl.brandName = this.allBrands.find(x => x.out_brand == pl.brand).out_brand_name;
                        });

                    },
                        (error: any) => {
                            console.info(error);
                        });
                    this.ngProgress.done();
                }
            },
            (error: any) => {
                console.info(error);
                this.ngProgress.done();
            });
        });
        this.ngProgress.done();
    }

    updateBrandList(event) {
        var selectedBrands = event.value;
        if (selectedBrands && selectedBrands.length > 0) {
            this.selectedBrandPromotionList = [];
            selectedBrands.forEach(sb => {
                this.promotionList.filter(pl => pl.brand.toLowerCase() == sb.toLowerCase()).forEach(fi => {
                    this.selectedBrandPromotionList.push(fi);
                })
            })
        }
        else
            this.selectedBrandPromotionList = this.promotionList;
    }

    filterPromotionList() {
        if (this.searchField.length > 0 && this.searchField.length < 3) {
            return;
        }
        else if (this.searchField.length == 0) {
            this.selectedBrandPromotionList = this.promotionList;
        }
        else {
            var search = this.searchField.toLocaleLowerCase();
            var result = this.selectedBrandPromotionList.filter((v, i) => {
                return (v.brand?.toLocaleLowerCase().includes(search) || v.title?.toLocaleLowerCase().includes(search) || v.description?.toLocaleLowerCase().includes(search));
            })
            this.selectedBrandPromotionList = result;          
        }
    }

    clearFilters() {
        this.searchField = "";
        this.brandSelect.update.emit([]);
        this.selectedBrands.length = 0;
        this.selectedBrandPromotionList = this.promotionList;
    }

    // changeMode(event): void {
    //     event.preventDefault();
    //     event.stopPropagation();
    //     this.narrowMode = true;
    // }

    ngOnDestroy(): void {
        // this.closesub$.unsubscribe();
    }

    close() {
        this.router.navigateByUrl('/');
        //this.ngProgress.done();
        //this.entry.clear();
        //this.created = false;
    }

    getCmsById(id) {
        this.cmsStudioService.getCmsById(id)
            .subscribe(res => {
                console.log(res);
                this.cms = res.count;
            })
    }

    clickEvent(e) {
        console.log(e.target.dataset.id);
        if (e.target.dataset.class == 'cmsTemplate' && this.viewChildId != e.target.dataset.id) {
            jQuery("app-cms-view-directive").hide();
            this.service.setRootViewContainerRef(this.viewContainerRef);
            this.service.addDynamicComponent(e.target.dataset.id);
            //this.viewChildId = e.target.dataset.id;
            $('.page-contents').animate({ scrollLeft: $('app-kbtemplate').width() }, 400);
        }
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }
    onNavigate(id, url) {
        this.marketingService.UpdatePromotionListAnalytics(id, this.commonService.analyticsClick).subscribe(value => {
            //success or error
            });
        window.open(url, '_blank');
    }
}